module.exports = __webpack_public_path__ + "img/Frame 794one.faa922e7.png";